import { render, staticRenderFns } from "./AuctionViewLogs.vue?vue&type=template&id=077b8c79"
import script from "./AuctionViewLogs.vue?vue&type=script&lang=js"
export * from "./AuctionViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports